export default "__VITE_ASSET__BgMWHIWY__"